import { AgGridReact } from "ag-grid-react";
import { useCallback, useEffect, useMemo, useState } from "react";

import { AllCommunityModule } from "ag-grid-community";
import "ag-grid-community/styles/ag-theme-quartz.css";
import * as XLSX from "xlsx";
//import CommonDateRangePicker from "../../utils/CommonDateRangePicker";
import CustomDateRange from "../../utils/CustomDateRange";
import { GetUserHierarchy } from "../../services/userService";
import { GetAdminOrderByStatusAndDate } from "../../services/orderService";
//import { GetOrderByStatusIdAndDate } from "../../services/orderService";

const modules = [AllCommunityModule];
const ListOrders = () => {
  const [totalRecords, setTotalRecords] = useState(0);
const [totalCodAmount, setTotalCodAmount] = useState(0);
const [totalPrepaidAmount, setTotalPrepaidAmount] = useState(0);
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState("");
  const [allRows, setAllRows] = useState([]);
  const [statusId, setStatusId] = useState(0); // 0 = All Status
  const userid = localStorage.getItem("userid");
  const today = new Date().toISOString().split("T")[0];
  const [dateRange, setDateRange] = useState({
    startDate: today,//"2026-06-01",
    endDate: today,//"2026-06-15",
  });
const [loading,setLoading]=useState(false);
  const handleDateChange = ({ startDate, endDate }) => {
  setDateRange({
    startDate,
    endDate,
  });
};

  const orderStatuses = [
  { id: 0, name: "All" },
  { id: 1, name: "In Process" },
  { id: 2, name: "Ready to ship" },
  { id: 3, name: "OFD" },
  { id: 4, name: "Delivered" },
  { id: 5, name: "Cancelled" },
  { id: 6, name: "Pincode not servicable" },
  { id: 7, name: "In Transit" },
  { id: 8, name: "NDR" },
  { id: 9, name: "Un Delivered" },
];

// Load Orders
  const fetchOrders = useCallback(async () => {
  try {
    setLoading(true);

    const response = await GetAdminOrderByStatusAndDate(
      Number(selectedUser || userid),
      statusId === 0 ? null : statusId,
      dateRange.startDate,
      dateRange.endDate
    );

    if (!response?.success || response.statusCode !== 200) {
      setAllRows([]);
      return;
    }

    setTotalRecords(response.data.totalRecords ?? 0);
    setTotalCodAmount(response.data.totalCodAmount ?? 0);
    setTotalPrepaidAmount(response.data.totalPrepaidAmount ?? 0);

    const formattedData = (response.data.orders ?? []).map((item) => ({
      id: item.id,
      orderId: item.id,
      orderType:item.orderType,
      dateCreated: item.dateCreated
        ? new Date(item.dateCreated).toLocaleString()
        : "",
      customerName: `${item.firstName ?? ""} ${item.lastName ?? ""}`.trim(),
      address: `${item.address ?? ""} ${item.address2 ?? ""}`.trim(),
      mobile: item.mobile ?? "",
      city: item.city ?? "",
      state: item.state ?? "",
      pincode: item.postalCode ?? "",
      totalAmount: item.gTotal ?? 0,
      paymentType: item.payment?.name ?? "",
      diseaseName: item.issueDisease?.name ?? "",
      creator: item.creator ?? "",
      teleCaller: item.teleCaller ?? "",
      teamLeader: item.teamLeader ?? "",
      courier: item.courier ?? "",
      ndrRemarks: item.ndrRemarks?.remarks || "",
      ndrStatus: item.ndrRemarks?.responseStatus || "",
      ndrDate: item.ndrRemarks?.ndrDate || "",
      courierStatus: item.courierStatus ?? "",
      wayBill: item.wayBill ?? "",
      product:
        item.getOrderItemDtos?.map((x) => x.productName).join(", ") || "",
      quantity:
        item.getOrderItemDtos?.reduce(
          (sum, x) => sum + (x.quantity || 0),
          0
        ) || 0,
      totalItem: item.getOrderItemDtos?.length || 0,
    }));

    setAllRows(formattedData);
  } catch (err) {
    console.error(err);
    setAllRows([]);
  } finally {
    setLoading(false);
  }
}, [selectedUser, userid, statusId, dateRange]);

 
  // Initial load only
 useEffect(() => {
  fetchOrders();
}, [fetchOrders]);


 const handleSearch = () => {
  fetchOrders(
    Number(selectedUser || userid),
    statusId,
    dateRange.startDate,
    dateRange.endDate
  );
};

 const formatRoles = useCallback((usersArray, parentPath = "") => {
        if (!Array.isArray(usersArray)) return [];

        let result = [];

        for (const user of usersArray) {
            const fullPath = parentPath
                ? `${parentPath} / ${user.userName}`
                : user.userName;

            result.push({
                id: user.id,
                name: fullPath,
            });

            if (user?.children?.length) {
                result = result.concat(formatRoles(user.children, fullPath));
            }
        }

        return result;
    }, []);

    
const fetchUserData = useCallback(async () => {
    try {
        const response = await GetUserHierarchy();

        if (response?.success && response.statusCode === 200) {
            setUsers(formatRoles(response.data));
        }
    } catch (err) {
        console.error(err);
    }
}, [formatRoles]);
    // End UserData

  // fetch users
   useEffect(() => {
    fetchUserData();
}, [fetchUserData]);

  // // Visible Rows
 
  const rowData = useMemo(() => {
    return allRows;
  }, [allRows]);

  

  // All Grid Columns
  const allColumnDefs = useMemo(
    () => [
      {
        field: "orderId",
        headerName: "Order Id",
      },
      { field: "orderType", headerName: "Order Type" },
      // {
      //   field: "promoCode",
      //   headerName: "Promo Code",
      // },

      {
        field: "dateCreated",
        headerName: "Date Created",
      },
      {
        field: "customerName",
        headerName: "Customer Name",
      },
      {
        field: "address",
        headerName: "Address",
      },
       {
        field: "mobile",
        headerName: "Mobile No",
      },
      {
        field: "pincode",
        headerName: "Pincode",
      },
      {
        field: "city",
        headerName: "City",
      },

      {
        field: "state",
        headerName: "State",
      },
      {
        field: "paymentType",
        headerName: "Payment Type",
      },
      {
        field: "wayBill",
        headerName: "Way Bill",
      },
      {
        field: "courier",
        headerName: "Courier",
      },
      {
        field: "courierStatus",
        headerName: "Courier Status",
      },
      {
        field: "ndrRemarks",
        headerName: "NDR Remarks",
      },
      {
        field: "ndrStatus",
        headerName: "NDR Status",
      },
      {
        field: "ndrDate",
        headerName: "NDR Date",
      },
      {
        field: "product",
        headerName: "Product",
      },
      {
        field: "totalItem",
        headerName: "Total Item",
      },
      {
        field: "quantity",
        headerName: "Quantity",
      },
      {
        field: "totalAmount",
        headerName: "Total Amount",
      },
      {
        field: "diseaseName",
        headerName: "Disease Name",
      },
      {
        field: "creator",
        headerName: "Creator",
      },
      {
        field: "teleCaller",
        headerName: "Tele Caller",
      },
      {
        field: "teamLeader",
        headerName: "Team Leader",
      },
    ],
    []
  );

  // Checkbox Columns
  const availableColumns = useMemo(() => {
    return allColumnDefs
      .filter((col) => col.field)
      .map((col) => ({
        field: col.field,
        headerName: col.headerName,
      }));
  }, [allColumnDefs]);

  // Default Selected Columns (All Checked)
  const [selectedColumns, setSelectedColumns] = useState([]);

  useEffect(() => {
    const saved = localStorage.getItem("orderColumns");

    if (saved) {
        setSelectedColumns(JSON.parse(saved));
    } else {
        setSelectedColumns(
            availableColumns.map(col => col.field)
        );
    }
}, [availableColumns]);
  useEffect(() => {
  if (selectedColumns.length > 0) {
    localStorage.setItem(
      "orderColumns",
      JSON.stringify(selectedColumns)
    );
  }
}, [selectedColumns]);

  // Checkbox Change
  const handleColumnChange = useCallback((field) => {
    setSelectedColumns((prev) =>
      prev.includes(field)
        ? prev.filter((x) => x !== field)
        : [...prev, field]
    );
  }, []);

  // Grid Columns Based On Checkbox
  const columnDefs = useMemo(() => {
    return allColumnDefs.filter(
      (col) => !col.field || selectedColumns.includes(col.field)
    );
  }, [allColumnDefs, selectedColumns]);


  // Reset Selection
  const resetColumns = () => {
    const allFields = availableColumns.map(
      (col) => col.field
    );

    setSelectedColumns(allFields);

    localStorage.removeItem("orderColumns");
  };


  const exportToExcel = () => {
    if (!rowData || rowData.length === 0) {
      alert("No data available to export");
      return;
    }

    // Get only visible/selected columns
    const exportColumns = columnDefs.filter(
    (c) => c.field && c.field !== "action"
);

    const exportData = rowData.map((row) => {
      const obj = {};

      exportColumns.forEach((col) => {
        obj[col.headerName || col.field] = row[col.field];
      });

      return obj;
    });

    const worksheet = XLSX.utils.json_to_sheet(exportData);

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(
      workbook,
      worksheet,
      "Orders"
    );

    XLSX.writeFile(
      workbook,
      `Orders_${new Date().toISOString().split("T")[0]}.xlsx`
    );
  };

  return (

    
    <div className="card p-3">
      {/* Header */}



      
      <div className="d-flex justify-content-between mb-3">
        <h5>List Orders</h5>


      </div>

      {/* Column Selection */}
      <div>
        <strong>Show Fields :</strong>

        <div className="d-flex flex-wrap gap-3 mt-2">
          {availableColumns.map((col) => (
            <label key={col.field}>
              <input
                type="checkbox"
                checked={selectedColumns.includes(
                  col.field
                )}
                onChange={() =>
                  handleColumnChange(col.field)
                }
              />{" "}
              {col.headerName}
            </label>
          ))}
        </div>
      </div>

      {/* Buttons */}
      <div className="mt-3">
        {/* <button
          className="btn btn-success btn-sm me-2"
          onClick={saveColumns}
        >
          Save
        </button> */}

        <button
          className="btn btn-danger btn-sm"
          onClick={resetColumns}
        >
          Reset
        </button>
      </div>
     
       <div className="row g-3 align-items-end mb-3">

  <div className="col-md-4">
    {/* <CommonDateRangePicker
      startDate={dateRange.startDate}
      endDate={dateRange.endDate}
      onApply={handleDateChange}
    /> */}
    <CustomDateRange
  startDate={dateRange.startDate}
  endDate={dateRange.endDate}
  onChange={handleDateChange}
/>
  </div>

  <div className="col-md-3">
    <select
      className="form-control"
      value={selectedUser}
      onChange={(e) => setSelectedUser(e.target.value)}
    >
      <option value="">Select User</option>

      {users.map((user) => (
        <option key={user.id} value={user.id}>
          {user.name}
        </option>
      ))}
    </select>
  </div>

  <div className="col-md-3">
    <select
  className="form-control"
  value={statusId}
  onChange={(e) => setStatusId(Number(e.target.value))}
>
  {orderStatuses.map((status) => (
    <option key={status.id} value={status.id}>
      {status.name}
    </option>
  ))}
</select>
  </div>

  <div className="col-md-2">
    <button
      className="btn btn-primary w-100"
      onClick={handleSearch}
      disabled={loading}
    >
      {loading ? "Loading..." : "Search"}
    </button>
  </div>

</div>

      <div className="d-flex justify-content-between align-items-center mb-3">

    <div className="d-flex gap-4">
        <strong>Total Orders: {totalRecords}</strong>

        <strong className="text-success">
            Total COD: ₹{totalCodAmount.toLocaleString()}
        </strong>

        <strong className="text-primary">
            Total Prepaid: ₹{totalPrepaidAmount.toLocaleString()}
        </strong>
    </div>

    <button
        className="btn btn-success btn-sm"
        onClick={exportToExcel}
    >
        Export Excel
    </button>

</div>
      {/* Grid */}
      <div
        className="ag-theme-quartz mt-3"
        style={{ height: "600px", width: "100%" }}
      >
        <AgGridReact
    modules={modules}
    rowData={rowData}
    columnDefs={columnDefs}
    animateRows
    pagination
    paginationPageSize={20}
    paginationPageSizeSelector={[20, 50, 100]}
    suppressRowClickSelection
    rowSelection="single"
    defaultColDef={{
        sortable: true,
        filter: true,
        floatingFilter: true,
        resizable: true,
        flex: 1,
        minWidth: 120,
    }}

    enableCellTextSelection={true}
    ensureDomOrder={true}
    // rowSelection="multiple"
    suppressClipboardPaste={true}

        />
      </div>
    </div>
  );
};

export default ListOrders;